import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { StorageMap } from '@ngx-pwa/local-storage';
import { GlobalService } from 'src/app/services/global/global.service';
import { SessionVerificationService } from 'src/app/services/session/session-verification.service';
import { UserRequestsService } from 'src/app/services/user/user-requests.service';

@Component({
  selector: 'app-modal-timeout',
  templateUrl: './modal-timeout.component.html',
  styleUrls: ['./modal-timeout.component.scss'],
})
export class ModalTimeoutComponent implements OnInit {
  constructor(
    public globalService: GlobalService,
    public dialogRef: MatDialogRef<ModalTimeoutComponent>,
    private userRequests: UserRequestsService,
    private storageMap: StorageMap,
    private router: Router,
    private sessionVerificationService: SessionVerificationService
  ) {}

  ngOnInit() {
    this.globalService.timeoutActive.subscribe((e) => {
      if (!e) {
        this.dialogRef.close();
      }
    });
  }

  refreshToken() {
    this.globalService.timeoutActive.next(true);
    this.userRequests.refreshToken().subscribe(() => this.dialogRef.close());
  }

  logout() {
    //this.userRequests.saveUserSessionTime().subscribe(() => {
    this.storageMap.clear().subscribe(() => {
      this.userRequests.resetCognito().subscribe(() => {
        this.dialogRef.close();
        this.userRequests.resetCognito();
        this.userRequests.resetUserData();
        localStorage.clear();
        this.sessionVerificationService.stopSessionVerification();
        this.router.navigate(['/login']).then(() => this.globalService.hideLoading());
      });
   });
  //})
  }
}
